import React, { Component } from "react";
import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Loadable from "react-loadable";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/views/PrivateRoute";
import Login from "./components/views/Login";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ForgotPassword from "./components/views/ForgotPassword";
import ChangePasswordFromReset from "./components/views/ChangePasswordFromReset";

const theme = createTheme({
  palette: {
    primary: { main: "#9dc001" }, // Purple and green play nicely together.
    secondary: { main: "#11cb5f" }, // This is just green.A700 as hex.
  },
});

const Loading = () => <div>Loading...</div>;

const Home = Loadable({
  loader: () => import("./components/pages/Home"),
  loading: Loading,
});

class App extends Component {
  state = {
    snackbarOpened: false,
  };

  snackbarClassNames = {
    INFO: "infobg",
    WARNING: "warningbg",
    ERROR: "errorbg",
  };

  handleSnackbarClose = (event, reason) => {
    //console.log('handleSnackbarClose', event, reason);
    this.setState({ snackbarOpened: false });
  };

  handleSnackbarOpen = (message, className) => {
    this.setState({
      snackbarOpened: true,
      snackbarMessage: typeof message === "string" ? message : message.message,
      snackbarClassName: className,
    });
  };

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/changePasswordFromReset" element={<ChangePasswordFromReset />} />

            <Route element={<PrivateRoute />}>
              <Route path="/admin" element={<Home />} />
            </Route>
          </Routes>
        </Router>
        <Snackbar
          className={this.state.snackbarClassName}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={this.state.snackbarOpened}
          autoHideDuration={4000}
          onClose={this.handleSnackbarClose}
          message={this.state.snackbarMessage}
          action={[
            <Button key="undo" color="default" size="small" onClick={this.handleSnackbarClose}>
              Close
            </Button>,
            <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleSnackbarClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </ThemeProvider>
    );
  }
}

export default App;
